export default {
      id: "phone-usage",
      viewBox: "0 0 25 25",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#phone",
      toString: function () {
        return this.url;
      }
    }